// ACTIVE -> Active (preetify word to lowcase and Capitalize first letter)
export const capitalizeFirstLetter = (
  string: string,
) => string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
